import { render, staticRenderFns } from "./Observation.vue?vue&type=template&id=2f5c041c&scoped=true&"
import script from "./Observation.vue?vue&type=script&lang=js&"
export * from "./Observation.vue?vue&type=script&lang=js&"
import style0 from "./Observation.vue?vue&type=style&index=0&id=2f5c041c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5c041c",
  null
  
)

export default component.exports